import { Facebook } from './tracking/Facebook'
import { GoogleAnalytics } from './tracking/GoogleAnalytics'
import { Hotjar } from './tracking/Hotjar'
import { TikTok } from './tracking/TikTok'

export const TrackingScripts = () => (
  <>
    <GoogleAnalytics />
    <Hotjar />
    <TikTok />
    <Facebook />
  </>
) 